<template>
  <div class="pass-set-box">
    <h1 class="">パスワード再設定</h1>
    <div v-if="mode == 1">
      <h2>新しいパスワードを設定してください。</h2>
      <div class="passset">
        <form method="post" @submit.prevent="send">
          <label class="label">新しいパスワード</label><span class="help is-danger" v-html="e_msg_u_pass"></span>
          <p class="control"><input type="password" name="user_pass" placeholder="パスワード" class="input" v-model="user_pass"></p>
          <label class="label">新しいパスワード(確認)</label><span class="help is-danger" v-html="e_msg_u_pass2"></span>
          <input type="password" name="user_pass" placeholder="パスワード(確認用)" class="input" v-model="user_pass2">
          <input class="button" type="submit" value="送信">
        </form>
      </div>
    </div>
    <div v-if="mode == 2">
      <h2>パスワードが再設定が完了しました。</h2>
    </div>
    <div v-if="mode == 3">
      <h2>無効のトークンです。<br />最初からやり直してください。</h2>
    </div>
    <div class="back">
      <a @click="cancel">← ログインページに戻る</a>
    </div>
    <div class="footer">
      Produced by
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassSet',

  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      e_msg_u_pass: '',
      e_msg_u_pass2: '',
      user_pass: '',
      user_pass2: '',
      mode: 0,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {

  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    if (this.$lib._emptyChk(this.$route.params.token, true) === true) {
      // token 確認
      let ld = new this.$loader(this);
      ld._data_set({preToken: this.$route.params.token});
      ld._post_cb_f = this.chk_cb;
      ld._load_start('/user/pass_set_token_check.php');
    } else {
      this.mode = 3;
    }
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    chk_cb (data) {
      if (data.res === 1) {
        this.mode = 1;
      } else if (data.res === this.$DF.RES_TOKEN_ERR) {
        this.mode = 3;
      } else {
        this.mode = 3;
      }
    },
    send () {
      let eFlg = false;
      if (!this.user_pass) {
        this.e_msg_u_pass = '新しいパスワードを入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_pass = '';
      }
      if (!this.user_pass2) {
        this.e_msg_u_pass2 = '新しいパスワード(確認)を入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_pass2 = '';
      }

      if (eFlg === false) {
        if (this.user_pass !== this.user_pass2) {
          this.$alert('alert', 'パスワードと確認用のパスワードが一致しません。');
          return;
        }
      }

      if (eFlg === false) {
        let ld = new this.$loader(this);
        ld._data_set({pass: this.user_pass, preToken: this.$route.params.token});
        ld._post_cb_f = this.send_cb;
        ld._load_start('/user/pass_set.php');
      }
    },
    send_cb (data) {
      if (data.res === 1) {
        this.mode = 2;
      } else if (data.res === this.$DF.RES_TOKEN_ERR) {
        this.mode = 3;
      } else {
        this.mode = 3;
      }
    },

    pass_reset () {
      this.$router.push({name: 'uPassReset', params: {}});
    },
    cancel () {
      this.$router.push({name: 'uLogin', params: {}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.pass-set-box {
  text-align: center;
  padding-top: 65px;
  h1 {
    color: #1b2010;
    font-size: 28px;
    letter-spacing: 2px;
  }
  h2 {
    font-size: 16px;
    font-weight: 100;
    color: #5b5845;
    margin: 34px 0 20px 0;
  }
  input {
    ime-mode: inactive;
    height: 48px;
    font-size: 18px;
  }

  .passset {
    position: relative;
    width: 400px;
    margin: 10px auto;
  }

  .control {
    margin-bottom: 17px;
  }

  .label {
    text-align: left;
    float: left;
    border-left: 6px solid #df274c;
    color: #5b5942;
    padding-left: 8px;
    margin-bottom: 5px;
  }

  .button {
    margin-top: 25px;
    width: 100%;
    height: 56px;
    color: #fefefe;
    border: initial;
    border-radius: 5px;
    font-size: 16px;
  }

  .help {
    color: #ff2626;
    font-size: 13px;
    line-height: 1.7;
  }
  .title-header {

  }
  .footer {
    background-image: url('../../assets/order_logo.svg');
    background-repeat: no-repeat;
    background-position: right;
    -ms-background-position-x: 55px;

    width: 256px;
    margin: 70px auto;
    text-align: left;
    height: 40px;
    line-height: 40px;
  }
  .back {
    margin-top: 30px;
    a {
      color: #da7d78;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  @media (max-width: 767px) {
    padding-top: 25px;
    .passset {
      width: calc(100vw - 110px);
      padding: 18px 15px 22px 15px;
    }
  }
}
</style>
